import { useEffect, useState } from "react";
import { useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import "./css/Login.css";
import {Link} from "react-router-dom";
import { Button, Col, Flex, Input, Row, Space, Typography, notification } from "antd";
import Logo from "../images/Lincfolio.png";
import Loginbg from "../images/loginbg.jpeg";
import Laptop from "../images/laptop.png";
import { KeyOutlined, LoginOutlined, MailOutlined } from "@ant-design/icons";
import { motion } from "framer-motion"

const LoginScreen = () => {

  const [api, contextHolder] = notification.useNotification();

  const { Title, Text } = Typography;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [login, { isLoading }] = useLoginMutation();

  const [show, setShow] = useState(false);
  const visible = () => {
    show ? setShow(false) : setShow(true)
  }

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
      try {
        const res = await login({ email, password }).unwrap();
        dispatch(setCredentials({ ...res }));
        navigate("/Dashboard");
      } catch (err) {
        console.log(err);
        api.error({
          message: err?.data?.message || err.error || err?.data?.error,
        });
        
      }
  }


  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await login({ email, password }).unwrap();
  //     dispatch(setCredentials({ ...res }));
  
  //     if (res.kiteLoginUrl) {
  //       // Redirect user to Kite Zerodha login
  //       window.location.href = res.kiteLoginUrl;
  //     } else {
  //       navigate("/Dashboard"); // fallback, if kite login not available
  //     }
  
  //   } catch (err) {
  //     console.log(err);
  //     api.error({
  //       message: err?.data?.message || err.error || err?.data?.error,
  //     });
  //   }
  // }
  
return (
<>
  {contextHolder}
  <form onSubmit={(e) => handleLogin(e)}>
  <Flex align="center" className="login-background" style={{height: "100vh"}} >
    <Row justify="space-around" style={{width: "100%"}}>
      <Col xs={{span: 22, order: 2}} lg={{span: 6, order: 1, offset: 2}} className="background-blur"  style={{ padding: "20px", height: "350px", boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.12)'}}>
        <h1>Login</h1>
        
          <Space direction='vertical' style={{width: "100%"}}>
            <Input placeholder="Email" addonBefore={<MailOutlined/>} onChange={(e) => setEmail(e.target.value)} required/>
            <Input.Password placeholder="Password" addonBefore={<KeyOutlined />} onChange={(e) => setPassword(e.target.value)} visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }} required/>
            <Flex justify="end">
              <p><Link to={"/forgotpassword"}> Forgot Password?</Link></p>
            </Flex>
            <Button type="primary" htmlType="submit" loading={isLoading}   className="gold-btn">Login <LoginOutlined/></Button>
            <Flex justify="start">
              <p>Don't have an account? Create new <Link to={"/register"}> account!</Link></p>
            </Flex>
          </Space>
      </Col>
      <Col xs={{span: 22, order: 1}} lg={{span: 16, order: 2}} style={{ padding: "20px", textAlign: "center" }}>
        {/* <motion.div   initial={{y: 100, opacity: 0}} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2 }}>
          <img src={Loginbg} alt="Lincfolio" className="logo" /><br/>
        </motion.div> */}
        {/* <motion.div   initial={{y: 100, opacity: 0}} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2, delay: 0.5 }}>
          <img src={Laptop} alt="Lincfolio-Laptop" className="laptop" /><br/>
        </motion.div> */}
        {/* <motion.div   initial={{y: 100, opacity: 0}} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2, delay: 1 }}>
          <p style={{fontSize: "18pt"}}>"Lincfolio, your trading tool, making profits easy and cool!"</p><br/>
        </motion.div> */}
      </Col>
    </Row>
  </Flex>
  </form>
</>
)
};
export default LoginScreen;

